import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { EvSpinner } from '@evinced-private/ui-common';

import { MfaWrapper } from 'src/apps/mfa/components/mfa-wrapper/MfaWrapper';
import { getMobileRedirectPath } from 'src/apps/mobile-common/helpers/MobileRedirectHelper';
import { MobileRedirect } from 'src/apps/mobile-common/pages/mobile-redirect/MobileRedirect';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';

export const MfaRedirect: FC = () => {
	const location = useLocation();
	const { configuration } = useConfiguration();

	if (!configuration) {
		return <EvSpinner />;
	}

	const isNewPlatformEnabled =
		configuration?.PLATFORM?.DEV_TOGGLES?.ENABLE_MFA_NEW_PLATFORM ?? false;
	const redirectPath = getMobileRedirectPath(
		location,
		RoutesHelper.getMfaDashboardPath(),
		RoutesHelper.getMfaV1DashboardPath()
	);

	return (
		<MobileRedirect
			isNewPlatformEnabled={isNewPlatformEnabled}
			redirectTo={redirectPath}
			router={<MfaWrapper />}
		/>
	);
};
